/**
 * Metafans Infinite Scroll
 * Handles lazy loading for Photos, Videos, and Documents using IntersectionObserver.
 */

class InfiniteLoader {
    constructor(type, buttonId, containerSelector, loaderSelector) {
        this.type = type;
        this.button = document.getElementById(buttonId);
        this.container = document.querySelector(containerSelector);
        this.loader = document.querySelector(loaderSelector);
        this.isLoading = false;

        if (this.button && this.container) {
            this.initObserver();
        }
    }

    initObserver() {
        const options = {
            rootMargin: '0px',
            threshold: 1.0
        };

        const callback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.isLoading && !this.button.disabled) {
                    this.loadMore();
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);
        observer.observe(this.button);
    }

    loadMore() {
        this.isLoading = true;
        this.button.disabled = true;
        if (this.loader) this.loader.style.display = 'block';

        const page = parseInt(this.button.dataset.page);
        const perPage = parseInt(this.button.dataset.perPage);
        const rawUserId = this.button.dataset.userId;
        const userId = rawUserId === 'false' ? false : parseInt(rawUserId);

        jQuery.ajax({
            url: Metafans_JS.ajaxurl, // Global WP var
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'load_more_photos', // Note: Original code uses 'load_more_photos' for all types
                type: this.type,
                page: page,
                per_page: perPage,
                user_id: userId,
            },
            success: (response) => this.handleSuccess(response),
            error: () => this.handleError()
        });
    }

    handleSuccess(response) {
        if (response.success) {
            // Append HTML
            // Note: Original code used specific classes for appending
            // .bp-image-previewer, .bp-video-previewer, etc.
            // Our constructor containerSelector handles this dynamic targeting.
            jQuery(this.container).append(response.data.html);

            if (response.data.has_more) {
                this.button.dataset.page = response.data.next_page;
                this.button.disabled = false;
            } else {
                this.button.remove();
            }
        } else {
            console.warn(`Failed to load ${this.type}.`);
            this.button.disabled = false;
        }

        this.finish();
    }

    handleError() {
        console.error(`Error loading ${this.type}.`);
        this.button.disabled = false;
        this.finish();
    }

    finish() {
        this.isLoading = false;
        if (this.loader) this.loader.style.display = 'none';
    }
}

export function initInfiniteScroll() {
    // Initialize specific instances
    new InfiniteLoader('photo', 'load-more-images', '.bp-image-previewer', '#bp-photos-loader');
    new InfiniteLoader('video', 'load-more-videos', '.bp-video-previewer', '#bp-videos-loader');
    new InfiniteLoader('document', 'load-more-documents', '.bp-document-previewer', '#bp-documents-loader');

    // Also handle standard Activity Loop "Load More" scrolling
    initActivityScroll();
}

function initActivityScroll() {
    const activityObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const link = entry.target.querySelector('a');
                if (link && !link.classList.contains('loading')) {
                    link.classList.add('loading');
                    link.click(); // Trigger BP's native AJAX click

                    // Cleanup old button after a delay (BP replaces it)
                    setTimeout(() => {
                        try { entry.target.remove(); } catch (e) { }
                    }, 500);
                }
            }
        });
    });

    // We observe the .load-more li element
    const checkAndObserve = () => {
        const loadMore = document.querySelector('#buddypress li.load-more');
        if (loadMore) activityObserver.observe(loadMore);
    };

    // Initial check and periodic check (since BP replaces DOM)
    checkAndObserve();
    // A mutation observer on the stream could be better, but simplified:
    document.addEventListener('ajaxComplete', checkAndObserve); // jQuery event fallback
}